import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable max-classes-per-file */
import { Component } from 'react';
import ErrorDisplay from './ErrorDisplay';
class ErrorBoundary extends Component {
    static getDerivedStateFromError(error) {
        return { error };
    }
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    componentDidCatch(error, info) {
        this.setState({ error });
        if (typeof Rollbar !== 'undefined') {
            Rollbar.error(error, { errorInfo: info });
        }
        if (typeof console !== 'undefined') {
            console.log(error); // eslint-disable-line no-console
            console.log(info); // eslint-disable-line no-console
        }
    }
    render() {
        var _a, _b;
        const errorType = (_a = this.props.errorType) !== null && _a !== void 0 ? _a : 'graphql';
        const placement = (_b = this.props.placement) !== null && _b !== void 0 ? _b : 'before';
        const { children } = this.props;
        if (!this.state.error) {
            return children;
        }
        const errorDisplayProps = (errorType !== null && errorType !== void 0 ? errorType : 'graphql') === 'graphql'
            ? { graphQLError: this.state.error }
            : { stringError: this.state.error.message };
        if (placement === 'before') {
            return (_jsxs(_Fragment, { children: [_jsx(ErrorDisplay, Object.assign({}, errorDisplayProps)), children] }));
        }
        if (placement === 'replace') {
            return _jsx(ErrorDisplay, Object.assign({}, errorDisplayProps));
        }
        return (_jsxs(_Fragment, { children: [children, _jsx(ErrorDisplay, Object.assign({}, errorDisplayProps))] }));
    }
}
export default ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map